/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7.625 3C8.91744 2.35486 10.4081 2 12.0002 2C17.0002 2 21.0002 5.5 21.0002 10.5C21.0002 12.1938 20.6745 13.6919 20.1435 15M12.0002 8C13.657 8 15.0002 9.34315 15.0002 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2L5.00853 5.00853M22 22L18.1962 18.1962M18.1962 18.1962C16.012 20.7683 13.162 21.9998 12 21.9998C10 21.9998 3 18.3518 3 10.5C3 8.33373 3.75084 6.44902 5.00853 5.00853M18.1962 18.1962L5.00853 5.00853"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M3 10.4998C3 18.3516 10 21.9996 12 21.9996C13.162 21.9996 16.012 20.7681 18.1962 18.196L5.00853 5.0083C3.75084 6.44879 3 8.3335 3 10.4998Z"
				fill="currentColor"
			/>
			<path
				d="M2 2L5.00853 5.00853M22 22L18.1962 18.1962M18.1962 18.1962C16.012 20.7683 13.162 21.9998 12 21.9998C10 21.9998 3 18.3518 3 10.5C3 8.33373 3.75084 6.44902 5.00853 5.00853M18.1962 18.1962L5.00853 5.00853M7.62481 3C8.91725 2.35486 10.4079 2 12 2C17 2 21 5.5 21 10.5C21 12.1938 20.6743 13.6919 20.1433 15M12 8C13.6569 8 15 9.34315 15 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L4.00237 5.06303C2.89348 6.55798 2.25 8.41601 2.25 10.5C2.25 14.6709 4.1156 17.7331 6.23437 19.739C7.29094 20.7393 8.41559 21.4828 9.41692 21.9791C10.3934 22.4631 11.3293 22.7498 12 22.7498C12.7706 22.7498 13.908 22.37 15.0796 21.7179C16.0959 21.1522 17.2056 20.3446 18.2236 19.2843L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L18.7265 17.6659L5.53886 4.4782L2.53033 1.46967ZM7.95977 3.67104C9.14409 3.07987 10.5195 2.75 12 2.75C16.6434 2.75 20.25 5.96961 20.25 10.5C20.25 12.0952 19.9437 13.4977 19.4483 14.7179C19.2925 15.1017 19.4774 15.5391 19.8612 15.6949C20.245 15.8507 20.6824 15.6659 20.8382 15.2821C21.4049 13.8861 21.75 12.2923 21.75 10.5C21.75 5.03039 17.3566 1.25 12 1.25C10.2963 1.25 8.69041 1.62984 7.28984 2.32896C6.91924 2.51395 6.76877 2.96436 6.95376 3.33496C7.13876 3.70557 7.58916 3.85604 7.95977 3.67104ZM12 7.25C11.5858 7.25 11.25 7.58579 11.25 8C11.25 8.41421 11.5858 8.75 12 8.75C13.2426 8.75 14.25 9.75736 14.25 11C14.25 11.4142 14.5858 11.75 15 11.75C15.4142 11.75 15.75 11.4142 15.75 11C15.75 8.92893 14.0711 7.25 12 7.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 2L5.00853 5.00853M22 22L18.1962 18.1962L5.00853 5.00853M5.00853 5.00853C3.75084 6.44902 3 8.33373 3 10.5C3 18.3518 10 21.9998 12 21.9998C12.6294 21.9998 13.7541 21.6385 15 20.8985C15.1648 20.8006 15.3318 20.6961 15.5 20.5849M7.62481 3C8.91725 2.35486 10.4079 2 12 2C17 2 21 5.5 21 10.5C21 12.1938 20.6743 13.6919 20.1433 15M12 8C13.6569 8 15 9.34315 15 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 2L5.00853 5.00853M22 22L18.1962 18.1962M18.1962 18.1962C16.012 20.7683 13.162 21.9998 12 21.9998C10 21.9998 3 18.3518 3 10.5C3 8.33373 3.75084 6.44902 5.00853 5.00853M18.1962 18.1962L5.00853 5.00853M7.62481 3C8.91725 2.35486 10.4079 2 12 2C17 2 21 5.5 21 10.5C21 12.1938 20.6743 13.6919 20.1433 15M12 8C13.6569 8 15 9.34315 15 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M4.44357 4.51514C3.06594 6.09299 2.25 8.15318 2.25 10.4999C2.25 14.6707 4.1156 17.7329 6.23437 19.7389C7.29094 20.7391 8.41559 21.4827 9.41692 21.979C10.3934 22.463 11.3293 22.7497 12 22.7497C12.7706 22.7497 13.908 22.3698 15.0796 21.7177C16.2804 21.0493 17.6116 20.0432 18.7679 18.6816L4.44357 4.51514Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.46967 1.46967C1.76256 1.17678 2.23744 1.17678 2.53033 1.46967L5.53886 4.4782L18.7265 17.6659L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L17.6659 18.7265L4.4782 5.53886L1.46967 2.53033C1.17678 2.23744 1.17678 1.76256 1.46967 1.46967ZM12.0002 2.75C10.5197 2.75 9.14429 3.07987 7.95996 3.67104C7.58935 3.85604 7.13895 3.70557 6.95396 3.33496C6.76896 2.96436 6.91943 2.51395 7.29004 2.32896C8.6906 1.62984 10.2965 1.25 12.0002 1.25C17.3568 1.25 21.7502 5.03039 21.7502 10.5C21.7502 12.2923 21.4051 13.8861 20.8384 15.2821C20.6826 15.6659 20.2452 15.8507 19.8614 15.6949C19.4776 15.5391 19.2927 15.1017 19.4485 14.7179C19.9439 13.4977 20.2502 12.0952 20.2502 10.5C20.2502 5.96961 16.6436 2.75 12.0002 2.75ZM11.2502 8C11.2502 7.58579 11.586 7.25 12.0002 7.25C14.0713 7.25 15.7502 8.92893 15.7502 11C15.7502 11.4142 15.4144 11.75 15.0002 11.75C14.586 11.75 14.2502 11.4142 14.2502 11C14.2502 9.75736 13.2428 8.75 12.0002 8.75C11.586 8.75 11.2502 8.41421 11.2502 8Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
